import { IProductWarehousesState } from "../@types";
import { productWarehouseActions } from "../action-types";


type ProductWarehousesActionType = { type: typeof productWarehouseActions.SWITCH_PRODUCT_WAREHOUSE_REFRESH_TABLE; payload: boolean }

const INITIAL_STATE: IProductWarehousesState = {
    refreshTableProductWarehouses: false,
}

export default function productWarehousesReducer(state: IProductWarehousesState = INITIAL_STATE, action: ProductWarehousesActionType): IProductWarehousesState{
    switch ( action.type ) {
        case productWarehouseActions.SWITCH_PRODUCT_WAREHOUSE_REFRESH_TABLE:
            return {
                ...state,
                refreshTableProductWarehouses: action.payload
            }
            default:
                return state
    }
}